import React from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { Banner } from '@zola/zola-ui';
import { CSSTransition } from 'react-transition-group';

import FeatureFlags from '../../../../util/featureFlags';

import GuestList from '../GuestList/GuestList';
import Toolbar from '../Toolbar/Toolbar';
import ViewSelector from '../ViewSelector/ViewSelector';
import ActionsBar from '../ActionsBar/ActionsBar';
import Tables from '../Tables/Tables';
import DragLayer from '../DragLayer/DragLayer';

const ListView = ({
  banner,
  numSelectedGuests,
  setView,
  tableCount
}) => {
  const { bannerType, bannerText } = banner;
  const bannerActive = (bannerType !== null) && (bannerText !== null);
  const duration = 300;

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="sc__container sc__container__list">
        <DragLayer numSelectedGuests={numSelectedGuests} />
        <aside className="sc__sidebar">
          <GuestList />
        </aside>
        <section className="sc__canvas">
          <CSSTransition in={bannerActive} timeout={duration} className="sc__listview-banner">
            <div>
              <Banner
                type={bannerType !== null ? bannerType : 'error'}
                text={bannerText !== null ? bannerText : ' '}
              />
            </div>
          </CSSTransition>
          <Toolbar>
            {FeatureFlags.get('seatingChartView2') && <ViewSelector setView={setView} />}
            <ActionsBar />
          </Toolbar>
          {tableCount === 0 && <div className="sc__empty-doodle">Add some tables to get started</div>}
          <div className="sc__tables-container">
            <Tables />
          </div>
        </section>
      </div>
    </DndProvider>
  );
};

ListView.propTypes = {
  banner: PropTypes.shape({
    bannerType: PropTypes.string,
    bannerText: PropTypes.string
  }),
  numSelectedGuests: PropTypes.number,
  setView: PropTypes.func.isRequired,
  tableCount: PropTypes.number,
};

export default ListView;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/ListView/ListView.jsx